var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.typeCheck === 'error')?_c('NotFound'):(this.gamespageData)?_c('main',{staticClass:"main-content-area"},[(
      !(
        this.gamespageData.meta &&
        this.gamespageData.meta.enable_different_free_game_url_for_mobile
      )
    )?[(!_vm.showData)?_c('div',{staticClass:"rotate-msg",style:({
        '--primary-bg': _vm.$root.color_schema.primary,
        '--primary-color': _vm.getContrastYIQ(_vm.$root.color_schema.primary)
          ? '#333'
          : '#fff',
      }),attrs:{"id":"rotate-msg"}},[_c('span',{staticClass:"rotate-svg"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"phoneIcon","viewBox":"0 0 100 180"}},[_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M90,0H10A10,10,0,0,0,0,10V170a10,10,0,0,0,10,10H90a10,10,0,0,0,10-10V10A10,10,0,0,0,90,0ZM4,24.51H96V150H4ZM10,4H90a6,6,0,0,1,6,6V20.51H4V10A6,6,0,0,1,10,4ZM90,176H10a6,6,0,0,1-6-6V154H96v16A6,6,0,0,1,90,176Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M40.63,14.25H59.37a2,2,0,1,0,0-4H40.63a2,2,0,0,0,0,4Z"}}),_vm._v(" "),_c('path',{staticClass:"cls-1",attrs:{"d":"M50,159.8a5.2,5.2,0,1,0,5.2,5.2A5.2,5.2,0,0,0,50,159.8Zm0,6.4a1.2,1.2,0,1,1,1.2-1.2A1.2,1.2,0,0,1,50,166.2Z"}})])])])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$root.i18n.please_turn_your_phone_to_enjoy_the_game))]),_vm._v(" "),_c('button',{staticClass:"cta cta-secondary cta-promotion cta-large cta-lg-br back-btn",on:{"click":function($event){_vm.showData = true}}},[_vm._v("\n        "+_vm._s(_vm.$root.i18n.go_back)+"\n      ")])]):_vm._e()]:_vm._e(),_vm._v(" "),(this.gamespageData.meta && this.gamespageData.meta.banner_image)?_c('section',{staticClass:"ct-inner-banner pt-26",style:({
      background:
        this.gamespageData.meta && this.gamespageData.meta.banner_image
          ? _vm.$root.color_schema.footer_bg
          : 'none',
    })},[_c('div',{staticClass:"container z-con"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":this.gamespageData.breadcrumb,"dark":_vm.getContrastYIQ(_vm.$root.color_schema.footer_bg)}})],1)]),_vm._v(" "),(Object.keys(_vm.introblockData).length > 0)?[_c('IntroBlock',{attrs:{"introBlockData":_vm.introblockData,"pageName":'game'}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"container z-con"},[(this.gamespageData.meta && this.gamespageData.meta.banner_image)?_c('div',{class:{
          row: !this.gameTemplate,
          'games-banner-block': this.gameTemplate,
        }},[_c('div',{class:[
            this.gameTemplate ? '' : 'col-md-8',
            'ct-inner-banner-lft',
            (this.gamespageData.meta.play_with_live_dealer &&
              this.gamespageData.meta.play_with_live_dealer.banner) ||
            (this.gamespageData.meta &&
              this.gamespageData.meta.our_expert_review &&
              Object.keys(this.gamespageData.meta.our_expert_review).length >
                0 &&
              this.gamespageData.meta.our_expert_review.reviewer_image)
              ? ''
              : 'banner-wd',
            !this.gameTemplate ||
            (this.gameTemplate &&
              _vm.gamesTop3 &&
              _vm.gamesTop3.length > 0 &&
              _vm.gamesTop3[0] &&
              _vm.gamesTop3[0].length > 0)
              ? ''
              : 'banner-wd' ]},[(_vm.showData)?_c('div',{class:{
              'game-space': true,
              'game-left':
                this.gameTemplate &&
                _vm.gamesTop3 &&
                _vm.gamesTop3.length > 0 &&
                _vm.gamesTop3[0] &&
                _vm.gamesTop3[0].length > 0,
            }},[(_vm.hideToplistLabelGB)?void 0:[(
                  this.gamespageData.meta.geo_provider_partners_data &&
                  this.gamespageData.meta.geo_provider_partners_data
                    .current &&
                  this.gamespageData.meta.geo_provider_partners_data.current
                    .go_link
                )?_c('a',{staticClass:"bg-link cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data.current
                    .product_name,"href":_vm.getGoLink(
                    this.gamespageData.meta.geo_provider_partners_data.current
                      .go_link,
                    this.gamespageData.meta.geo_provider_partners_data.current
                      .slug
                  ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                    ? 'nofollow sponsored'
                    : 'nofollow'}}):_vm._e()],_vm._v(" "),(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(this.gamespageData.meta.banner_image),expression:"this.gamespageData.meta.banner_image"}],class:{
                'banner-img-im':
                  !this.gameTemplate ||
                  !(
                    this.gameTemplate &&
                    _vm.gamesTop3 &&
                    _vm.gamesTop3.length > 0 &&
                    _vm.gamesTop3[0] &&
                    _vm.gamesTop3[0].length > 0
                  ),
                'banner-img':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
                'game-left':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
              },attrs:{"width":"860","height":"557","alt":"Banner Image"}}):_c('img',{class:{
                'banner-img-im':
                  !this.gameTemplate ||
                  !(
                    this.gameTemplate &&
                    _vm.gamesTop3 &&
                    _vm.gamesTop3.length > 0 &&
                    _vm.gamesTop3[0] &&
                    _vm.gamesTop3[0].length > 0
                  ),
                'banner-img':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
                'game-left':
                  this.gameTemplate &&
                  _vm.gamesTop3 &&
                  _vm.gamesTop3.length > 0 &&
                  _vm.gamesTop3[0] &&
                  _vm.gamesTop3[0].length > 0,
              },attrs:{"src":this.gamespageData.meta.banner_image,"width":"860","height":"557","alt":"Banner Image"}}),_vm._v(" "),_c('div',{staticClass:"game-space-content"},[(
                  !_vm.$root.disable_freegame_banner_outlink &&
                  this.gamespageData.meta.geo_provider_partners_data &&
                  this.gamespageData.meta.geo_provider_partners_data.current
                )?_c('div',{staticClass:"game-logo"},[(_vm.hideToplistLabelGB)?void 0:[_c('a',{staticClass:"partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                        .current.product_name,"href":_vm.getGoLink(
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link,
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[(
                        _vm.$root.enable_lazyload &&
                        _vm.assets_images &&
                        _vm.assets_images.pro_asset_sizes &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.product_assets.length > 0
                      )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                        this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.medium; }
                        ).length > 0
                          ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : ''
                      ),expression:"\n                        this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                          (ele) =>\n                            ele.asset_category_name ===\n                            assets_images.pro_asset_sizes.medium\n                        ).length > 0\n                          ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                              .filter(\n                                (ele) =>\n                                  ele.asset_category_name ===\n                                  assets_images.pro_asset_sizes.medium\n                              )\n                              .shift().url\n                          : ''\n                      "}],attrs:{"width":"136","height":"136","alt":_vm.getAltText(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        )}}):(
                        _vm.assets_images &&
                        _vm.assets_images.pro_asset_sizes &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.product_assets.length > 0
                      )?_c('img',{attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                          function (ele) { return ele.asset_category_name ===
                            _vm.assets_images.pro_asset_sizes.medium; }
                        ).length > 0
                          ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                              .filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              )
                              .shift().url
                          : _vm.$root.site_url + _vm.$root.asset_path + '/failure.png',"width":"136","height":"136","alt":_vm.getAltText(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png'
                        )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-bann"},[_c('div',{staticClass:"partner-hover-inner",style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                        Object.keys(
                          _vm.hasTag(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.tags
                          )
                        ).length > 0
                      )?_c('div',{staticClass:"stripe-gam",style:({
                        backgroundColor:
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                            ? _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).color
                            : null,
                      })},[_c('span',{class:{
                          'custom-font-2': true,
                          'text-gray': _vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null
                          ),
                          'text-light': !_vm.getContrastYIQ(
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null
                          ),
                        }},[_c('img',{attrs:{"src":_vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                        "+_vm._s(_vm.titleCase(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            ).tag_name
                          ))+"\n                      ")])]):_vm._e()])]],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-block"},[(!_vm.$root.disable_freegame_banner_outlink)?[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current
                      )?_c('a',{class:{
                        'cta cta-primary cta-promotion custom-btn cas-link hover-btn ': true,
                        'text-white game-btn':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(this.gamespageData.meta.play_for_real_label))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()]]:_vm._e(),_vm._v(" "),(_vm.checkPlayFreeButton())?_c('a',{staticClass:"cta cta-primary cta-promotion cta-outline",attrs:{"title":this.gamespageData.meta.play_for_free_label,"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showIframe()}}},[_vm._v(_vm._s(this.gamespageData.meta.play_for_free_label))]):_vm._e()],2)])],2):_c('div',{staticClass:"game-space"},[(!_vm.$root.disable_freegame_banner_outlink)?[(_vm.hideToplistLabelGB)?void 0:[(
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('a',{staticClass:"game_review_flex cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data.current
                      .product_name,"href":_vm.getGoLink(
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.go_link,
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.slug
                    ),"id":"game_review_flex","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow',"target":"_blank"}},[_c('div',{staticClass:"sticky-review-card"},[_c('div',{staticClass:"sticky-inner-wrapper"},[_c('a',{staticClass:"affliate-logo partner-logo cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[(
                            _vm.$root.enable_lazyload &&
                            _vm.assets_images &&
                            _vm.assets_images.pro_asset_sizes
                          )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : ''
                          ),expression:"\n                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                              (ele) =>\n                                ele.asset_category_name ===\n                                assets_images.pro_asset_sizes.large\n                            ).length > 0\n                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                  .filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.large\n                                  )\n                                  .shift().url\n                              : ''\n                          "}],attrs:{"width":"65","height":"65","alt":_vm.getAltText(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current
                                .product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.large; }
                                    )
                                    .shift().url
                                : ''
                            )}}):(
                            _vm.assets_images && _vm.assets_images.pro_asset_sizes
                          )?_c('img',{attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.large; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.large; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                _vm.$root.asset_path +
                                '/failure.png',"width":"65","height":"65","alt":_vm.getAltText(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current
                                .product_name,
                              this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.large; }
                              ).length > 0
                                ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                    .filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.large; }
                                    )
                                    .shift().url
                                : _vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/failure.png'
                            )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-stick"},[_c('div',{staticClass:"partner-hover-inner",style:({
                              '--primary-btn': _vm.$root.color_schema.primary_btn,
                              '--primary-btn-hover': _vm.pSBC(
                                -0.2,
                                _vm.$root.color_schema.primary_btn
                              ),
                            })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])]),_vm._v(" "),_c('span',{staticClass:"sticky-text stick-part-1"},[_c('span',{staticClass:"sticky-title text-hover",staticStyle:{"font-size":"1.175rem","font-weight":"700"}},[_vm._v(_vm._s(this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name))]),_vm._v(" "),_c('span',{staticClass:"bonus-text"},[_c('div',{staticClass:"pt-6px"},[(
                                Object.keys(
                                  _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  )
                                ).length > 0
                              )?_c('div',{class:{
                                'top-choice-card': true,
                                'font-dark': _vm.getContrastYIQ(
                                  Object.keys(
                                    _vm.hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current
                                        .tags
                                    )
                                  ).length > 0
                                    ? _vm.hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      ).color
                                    : null
                                ),
                                'font-light': !_vm.getContrastYIQ(
                                  Object.keys(
                                    _vm.hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current
                                        .tags
                                    )
                                  ).length > 0
                                    ? _vm.hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      ).color
                                    : null
                                ),
                              },style:({
                                backgroundColor:
                                  Object.keys(
                                    _vm.hasTag(
                                      this.gamespageData.meta
                                        .geo_provider_partners_data.current
                                        .tags
                                    )
                                  ).length > 0
                                    ? _vm.hasTag(
                                        this.gamespageData.meta
                                          .geo_provider_partners_data.current
                                          .tags
                                      ).color
                                    : null,
                              })},[_c('img',{attrs:{"src":_vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                              "+_vm._s(_vm.titleCase(
                                  _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).tag_name
                                ))+"\n                            ")]):_vm._e()])])]),_vm._v(" "),_c('span',{staticClass:"sticky-text text-hover stick-part-2",staticStyle:{"margin":"auto"}},[_c('span',{staticClass:"bonus-text"},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                              _vm.$root.i18n.get_best_bonus_for_this_game,
                              this.gamespageData.meta
                                .geo_provider_partners_data.current
                                .product_name
                            ))+"!")]),_vm._v(" "),(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc != ''
                          )?_c('div',{staticClass:"termsgam",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                          }),domProps:{"innerHTML":_vm._s(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc
                          )}}):_vm._e(),_vm._v(" "),(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.bonus_tc != '' &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms != ''
                          )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.terms != ''
                          )?_c('a',{staticClass:"terms_tc cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"title":this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,"href":_vm.getGoLink(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.term_link,
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.slug
                            ),"target":"_blank"}},[_vm._v(_vm._s(this.gamespageData.meta.geo_provider_partners_data
                              .current.terms))]):_vm._e()]),_vm._v(" "),_c('a',{class:{
                          'cta cta-primary cta-promotion cta-promo-review sticky-play-btn custom-btn hover-btn cas-link': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(this.gamespageData.meta.geo_provider_partners_data
                            .current.cta_button_text))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambspp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2)])])]):_vm._e()]]:_vm._e(),_vm._v(" "),(
                !(
                  this.gamespageData.meta &&
                  this.gamespageData.meta
                    .enable_different_free_game_url_for_mobile
                )
              )?[_c('fullscreen',{ref:"fullscreen"},[_c('div',{class:{
                    'wrapper-iframe': true,
                    'wrapper-game-iframe':
                      this.gameTemplate &&
                      _vm.gamesTop3 &&
                      _vm.gamesTop3.length > 0 &&
                      _vm.gamesTop3[0] &&
                      _vm.gamesTop3[0].length > 0,
                  },attrs:{"id":"wrapper-iframe"}},[_c('iframe',{staticClass:"cas-iframe",attrs:{"id":"cas-iframe","src":this.gamespageData.meta.play_for_free_url},on:{"load":function($event){return _vm.openFullscreen()}}})]),_vm._v(" "),(
                    !_vm.$root.disable_freegame_banner_outlink &&
                    _vm.gameOverlay &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('div',{staticClass:"cta-overlay",style:({
                    'background-color': _vm.color,
                    '--primary-color': _vm.getContrastYIQ('#060236')
                      ? '#333'
                      : '#fff',
                  })},[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"img-cas partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[(
                          _vm.$root.enable_lazyload &&
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        ),expression:"\n                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.medium\n                          ).length > 0\n                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                )\n                                .shift().url\n                            : ''\n                        "}],staticClass:"img-over",attrs:{"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          )}}):(
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{staticClass:"img-over",attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-ifrm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                        )?_c('div',{staticClass:"stripe-gam-overlay",style:({
                          backgroundColor:
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        })},[_c('span',{class:{
                            'custom-font-2': true,
                            'text-gray': _vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !_vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }},[_c('img',{attrs:{"src":_vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                          "+_vm._s(_vm.titleCase(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            ))+"\n                        ")])]):_vm._e()]):_vm._e()],_vm._v(" "),(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.rating
                    )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          (
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.rating / 2
                          ).toFixed(1)
                        ),"noText":""}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"how-about"},[_vm._v(_vm._s(_vm.$root.i18n.how_about_a_special_offer_from)+"\n                    "+_vm._s(this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                        ? this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        : "")+"\n                    ?")]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"get-a cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.$root.i18n.get_best_bonus_for_this_game)+"!!")]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[(_vm.hideToplistLabelGB)?void 0:[(
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        )?_c('a',{class:{
                          'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.$root.i18n.get_bonus))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsppp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()],_vm._v(" "),_c('span',{staticClass:"\n                        cta cta-secondary cta-promotion cta-lg-br\n                        back-btn\n                        ct-btn\n                      ",on:{"click":function($event){return _vm.overlayHide()}}},[_vm._v(_vm._s(_vm.$root.i18n.no_thanks))])],2)],2):_vm._e()])]:[(
                  _vm.widthofgamesection < 576 &&
                  this.gamespageData.meta &&
                  this.gamespageData.meta.mobile_game_iframe_url &&
                  this.gamespageData.meta.mobile_game_iframe_url != ''
                )?[_c('div',{class:{
                    'wrapper-iframe': true,
                    'wrapper-game-iframe':
                      this.gameTemplate &&
                      _vm.gamesTop3 &&
                      _vm.gamesTop3.length > 0 &&
                      _vm.gamesTop3[0] &&
                      _vm.gamesTop3[0].length > 0,
                  },attrs:{"id":"wrapper-iframe"}},[_c('iframe',{staticClass:"cas-iframe",attrs:{"id":"cas-iframe","src":this.gamespageData.meta.mobile_game_iframe_url},on:{"load":function($event){return _vm.openFullscreen()}}})]),_vm._v(" "),(
                    !_vm.$root.disable_freegame_banner_outlink &&
                    _vm.gameOverlay &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('div',{staticClass:"cta-overlay cta-overlay-enable-mobile",style:({
                    'background-color': _vm.color,
                    '--primary-color': _vm.getContrastYIQ('#060236')
                      ? '#333'
                      : '#fff',
                  })},[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"img-cas partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[(
                          _vm.$root.enable_lazyload &&
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        ),expression:"\n                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.medium\n                          ).length > 0\n                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                )\n                                .shift().url\n                            : ''\n                        "}],staticClass:"img-over",attrs:{"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          )}}):(
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{staticClass:"img-over",attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-ifrm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                        )?_c('div',{staticClass:"stripe-gam-overlay",style:({
                          backgroundColor:
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        })},[_c('span',{class:{
                            'custom-font-2': true,
                            'text-gray': _vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !_vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }},[_c('img',{attrs:{"src":_vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                          "+_vm._s(_vm.titleCase(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            ))+"\n                        ")])]):_vm._e()]):_vm._e()],_vm._v(" "),(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.rating
                    )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          (
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.rating / 2
                          ).toFixed(1)
                        ),"noText":""}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"how-about"},[_vm._v(_vm._s(_vm.$root.i18n.how_about_a_special_offer_from)+"\n                    "+_vm._s(this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                        ? this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        : "")+"\n                    ?")]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"get-a cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.$root.i18n.get_best_bonus_for_this_game)+"!!")]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[(_vm.hideToplistLabelGB)?void 0:[(
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        )?_c('a',{class:{
                          'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.$root.i18n.get_bonus))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsppp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()],_vm._v(" "),_c('span',{staticClass:"\n                        cta cta-secondary cta-promotion cta-lg-br\n                        back-btn\n                        ct-btn\n                      ",on:{"click":function($event){return _vm.overlayHide()}}},[_vm._v(_vm._s(_vm.$root.i18n.no_thanks))])],2)],2):_vm._e()]:[_c('div',{class:{
                    'wrapper-iframe': true,
                    'wrapper-game-iframe':
                      this.gameTemplate &&
                      _vm.gamesTop3 &&
                      _vm.gamesTop3.length > 0 &&
                      _vm.gamesTop3[0] &&
                      _vm.gamesTop3[0].length > 0,
                  },attrs:{"id":"wrapper-iframe"}},[_c('iframe',{staticClass:"cas-iframe",attrs:{"id":"cas-iframe","src":this.gamespageData.meta.play_for_free_url},on:{"load":function($event){return _vm.openFullscreen()}}})]),_vm._v(" "),(
                    !_vm.$root.disable_freegame_banner_outlink &&
                    _vm.gameOverlay &&
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('div',{staticClass:"cta-overlay",style:({
                    'background-color': _vm.color,
                    '--primary-color': _vm.getContrastYIQ('#060236')
                      ? '#333'
                      : '#fff',
                  })},[(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"img-cas partner-logo cas-link gam-strp",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[(
                          _vm.$root.enable_lazyload &&
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : ''
                        ),expression:"\n                          this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(\n                            (ele) =>\n                              ele.asset_category_name ===\n                              assets_images.pro_asset_sizes.medium\n                          ).length > 0\n                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets\n                                .filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                )\n                                .shift().url\n                            : ''\n                        "}],staticClass:"img-over",attrs:{"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : ''
                          )}}):(
                          _vm.assets_images &&
                          _vm.assets_images.pro_asset_sizes &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_assets.length > 0
                        )?_c('img',{staticClass:"img-over",attrs:{"src":this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                            function (ele) { return ele.asset_category_name ===
                              _vm.assets_images.pro_asset_sizes.medium; }
                          ).length > 0
                            ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                .filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                )
                                .shift().url
                            : _vm.$root.site_url +
                              _vm.$root.asset_path +
                              '/failure.png',"width":"102","height":"102","alt":_vm.getAltText(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.product_name,
                            this.gamespageData.meta.geo_provider_partners_data.current.product_assets.filter(
                              function (ele) { return ele.asset_category_name ===
                                _vm.assets_images.pro_asset_sizes.medium; }
                            ).length > 0
                              ? this.gamespageData.meta.geo_provider_partners_data.current.product_assets
                                  .filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )
                                  .shift().url
                              : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png'
                          )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-ifrm"},[_c('div',{staticClass:"partner-hover-inner",style:({
                            '--primary-btn': _vm.$root.color_schema.primary_btn,
                            '--primary-btn-hover': _vm.pSBC(
                              -0.2,
                              _vm.$root.color_schema.primary_btn
                            ),
                          })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(
                          Object.keys(
                            _vm.hasTag(
                              this.gamespageData.meta
                                .geo_provider_partners_data.current.tags
                            )
                          ).length > 0
                        )?_c('div',{staticClass:"stripe-gam-overlay",style:({
                          backgroundColor:
                            Object.keys(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              )
                            ).length > 0
                              ? _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                ).color
                              : null,
                        })},[_c('span',{class:{
                            'custom-font-2': true,
                            'text-gray': _vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                            'text-light': !_vm.getContrastYIQ(
                              Object.keys(
                                _vm.hasTag(
                                  this.gamespageData.meta
                                    .geo_provider_partners_data.current.tags
                                )
                              ).length > 0
                                ? _vm.hasTag(
                                    this.gamespageData.meta
                                      .geo_provider_partners_data.current.tags
                                  ).color
                                : null
                            ),
                          }},[_c('img',{attrs:{"src":_vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).icon,"width":"18","height":"12","alt":"tag-icons"}}),_vm._v("\n                          "+_vm._s(_vm.titleCase(
                              _vm.hasTag(
                                this.gamespageData.meta
                                  .geo_provider_partners_data.current.tags
                              ).tag_name
                            ))+"\n                        ")])]):_vm._e()]):_vm._e()],_vm._v(" "),(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.rating
                    )?_c('div',{staticClass:"best-rating"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          (
                            this.gamespageData.meta
                              .geo_provider_partners_data &&
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.rating / 2
                          ).toFixed(1)
                        ),"noText":""}})],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"how-about"},[_vm._v(_vm._s(_vm.$root.i18n.how_about_a_special_offer_from)+"\n                    "+_vm._s(this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current &&
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                        ? this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name
                        : "")+"\n                    ?")]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                        this.gamespageData.meta.geo_provider_partners_data &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current &&
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link
                      )?_c('a',{staticClass:"get-a cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                          .current.product_name,"href":_vm.getGoLink(
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link,
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.slug
                        ),"rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow',"target":"_blank"}},[_vm._v(_vm._s(_vm.$root.i18n.get_best_bonus_for_this_game)+"!!")]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"text-wrapper"},[(_vm.hideToplistLabelGB)?void 0:[(
                          this.gamespageData.meta
                            .geo_provider_partners_data &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current &&
                          this.gamespageData.meta.geo_provider_partners_data
                            .current.go_link
                        )?_c('a',{class:{
                          'cta cta-block cta-primary cta-promotion custom-btn cas-link hover-btn ct-btn': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                            .current.product_name,"href":_vm.getGoLink(
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.go_link,
                            this.gamespageData.meta.geo_provider_partners_data
                              .current.slug
                          ),"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"target":"_blank"}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(_vm.$root.i18n.get_bonus))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsppp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()],_vm._v(" "),_c('span',{staticClass:"\n                        cta cta-secondary cta-promotion cta-lg-br\n                        back-btn\n                        ct-btn\n                      ",on:{"click":function($event){return _vm.overlayHide()}}},[_vm._v(_vm._s(_vm.$root.i18n.no_thanks))])],2)],2):_vm._e()]]],2)]),_vm._v(" "),_c('div',{class:{
            'col-md-4': !this.gameTemplate,
            'game-right':
              this.gameTemplate &&
              _vm.gamesTop3 &&
              _vm.gamesTop3.length > 0 &&
              _vm.gamesTop3[0] &&
              _vm.gamesTop3[0].length > 0,
            'ct-inner-banner-rgt':
              (this.gameTemplate &&
                _vm.gamesTop3 &&
                _vm.gamesTop3.length > 0 &&
                _vm.gamesTop3[0] &&
                _vm.gamesTop3[0].length > 0) ||
              !this.gameTemplate,
          }},[(this.gameTemplate)?[(_vm.gamesTop3.length > 0)?_vm._l((_vm.gamesTop3),function(val,index){return _c('div',{key:index},[_c(_vm.titleComponent,{tag:"component",class:{
                      'text-white gm-title': true, 
                      'cust-h1': _vm.titleComponent === 'span'   
                  }},[_vm._v("\n                  "+_vm._s(_vm.gamesTop3Title[index])+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"mobile-scroller"},_vm._l((val),function(data,index){return _c('div',{key:index,staticClass:"play-card",style:({
                      'border': index === 0 ? "2px solid #ffd03a" : null,
                      'background-color': index === 0 ? '#FFF9E8' : null,
                      'overflow': 'hidden'
                    })},[_c('div',{class:("play-card-index play-card-index-" + index)},[_vm._v(_vm._s(index + 1))]),_vm._v(" "),_c('div',{staticClass:"play-card-top"},[_c('div',{staticClass:"play-card-top-img"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"rel":_vm.$root.change_cta_to_sponsored
                              ? 'nofollow sponsored'
                              : 'nofollow',"target":"_blank"}},[(
                              _vm.$root.enable_lazyload &&
                              _vm.assets_images &&
                              _vm.assets_images.pro_asset_sizes
                            )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                              data.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )[0].url
                                : ''
                            ),expression:"\n                              data.product_assets.filter(\n                                (ele) =>\n                                  ele.asset_category_name ===\n                                  assets_images.pro_asset_sizes.medium\n                              ).length > 0\n                                ? data.product_assets.filter(\n                                    (ele) =>\n                                      ele.asset_category_name ===\n                                      assets_images.pro_asset_sizes.medium\n                                  )[0].url\n                                : ''\n                            "}],attrs:{"width":"40","height":"40","alt":_vm.getAltText(
                                data.product_name,
                                data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : ''
                              )}}):(
                              _vm.assets_images && _vm.assets_images.pro_asset_sizes
                            )?_c('img',{attrs:{"src":data.product_assets.filter(
                                function (ele) { return ele.asset_category_name ===
                                  _vm.assets_images.pro_asset_sizes.medium; }
                              ).length > 0
                                ? data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  )[0].url
                                : _vm.$root.site_url +
                                  _vm.$root.asset_path +
                                  '/failure.png',"width":"40","height":"40","alt":_vm.getAltText(
                                data.product_name,
                                data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : _vm.$root.site_url +
                                      _vm.$root.asset_path +
                                      '/failure.png'
                              )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-cas"},[_c('div',{staticClass:"partner-hover-inner",style:({
                                '--primary-btn':
                                  _vm.$root.color_schema.primary_btn,
                                '--primary-btn-hover': _vm.pSBC(
                                  -0.2,
                                  _vm.$root.color_schema.primary_btn
                                ),
                              })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"play-card-top-right"},[(_vm.$root.enable_piwik_reload)?[(data.review_link)?_c('a',{staticClass:"casino-title text-hover",attrs:{"title":data.product_name,"href":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                _vm.$root.i18n.partner_name_review,
                                data.product_name
                              )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]:[(data.review_link)?_c('router-link',{staticClass:"casino-title text-hover",attrs:{"title":data.product_name,"to":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                                _vm.$root.i18n.partner_name_review,
                                data.product_name
                              )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])],_vm._v(" "),_c('StarRating',{attrs:{"rating":parseFloat((data.rating / 2).toFixed(1))}})],2)]),_vm._v(" "),_c('div',{staticClass:"play-card-mid"},[_c('span',{staticClass:"span-h5 custom-font-1 game-bonus-text"},[(_vm.hideBonusLabelGB)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[_c('a',{staticClass:"bonus-link custom-font-1 cas-link",style:({
                              '--color-hover': _vm.$root.color_schema.primary_btn,
                            }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'}},[(
                                data.bonus_match &&
                                data.exclusive_bonus_amount &&
                                data.exclusive_bonus_match
                              )?_c('span',[_vm._v(_vm._s(data.exclusive_bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                              "+_vm._s(_vm._f("currency")(data.exclusive_bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                                data.bonus_match &&
                                !data.exclusive_bonus_amount &&
                                data.bonus_amount
                              )?_c('span',[_vm._v(_vm._s(data.bonus_match)+"%\n                              "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                              "+_vm._s(_vm._f("currency")(data.bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(data.freespin || data.freebie_name)?_c('span',[(
                                  (data.exclusive_bonus_amount ||
                                    data.bonus_amount) &&
                                  data.bonus_match
                                )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(data.freespin)?[(data.show_freebie_currency === '1')?[_vm._v(_vm._s(_vm._f("currency")(data.freespin,data.bonus_currency)))]:[_vm._v(_vm._s(data.freespin))],_vm._v("\n                                "+_vm._s(data.freebie_name)+"\n                              ")]:[_vm._v(_vm._s(data.freebie_name))]],2):_vm._e()])]],2)]),_vm._v(" "),_c('a',{class:{
                        'cta cta-primary cta-promotion cta-block custom-btn cta-game-large hover-btn cas-link': true,
                        'text-white':
                          !_vm.$root.override_ctabtntxt_color &&
                          !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-gray':
                          !_vm.$root.override_ctabtntxt_color &&
                          _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                        'text-cta-override': _vm.$root.override_ctabtntxt_color,
                      },style:({
                        '--primary-btn': _vm.$root.color_schema.primary_btn,
                        '--primary-btn-hover': _vm.pSBC(
                          -0.2,
                          _vm.$root.color_schema.primary_btn
                        ),
                      }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                          ? 'nofollow sponsored'
                          : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 0)?_c('img',{attrs:{"src":_vm.crownIcon,"alt":"Crown","height":"16","width":"24"}}):_vm._e(),_vm._v("\n                        "+_vm._s(data.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gamcpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2),_vm._v(" "),(
                        (data.bonus_tc && data.bonus_tc != '') ||
                        (data.terms && data.terms != '')
                      )?_c('div',{staticClass:"gm-terms"},[(data.bonus_tc && data.bonus_tc != '')?_c('span',{staticClass:"cas-term game-terms-text",staticStyle:{"text-align":"center"},style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                        }),domProps:{"innerHTML":_vm._s(data.bonus_tc.trim())}}):_vm._e(),_vm._v(" "),(
                          data.bonus_tc &&
                          data.terms &&
                          data.bonus_tc != '' &&
                          data.terms != ''
                        )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(data.terms && data.terms != '')?_c('a',{staticClass:"cas-term game-terms-text",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"title":data.product_name,"href":_vm.getGoLink(data.term_link, data.slug),"target":"_blank"}},[_vm._v(_vm._s(data.terms))]):_vm._e()]):_vm._e()])}),0)],1)}):_vm._e()]:[(
                this.gamespageData.meta.play_with_live_dealer &&
                this.gamespageData.meta.play_with_live_dealer.banner
              )?_c('div',{staticClass:"live-dealer"},[(_vm.hideToplistLabelGB)?void 0:[(
                    this.gamespageData.meta.geo_provider_partners_data &&
                    this.gamespageData.meta.geo_provider_partners_data.current
                  )?_c('a',{staticClass:"bg-link cas-link",attrs:{"title":this.gamespageData.meta.geo_provider_partners_data.current
                      .product_name,"href":_vm.getGoLink(
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.go_link,
                      this.gamespageData.meta.geo_provider_partners_data
                        .current.slug
                    ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                      ? 'nofollow sponsored'
                      : 'nofollow'}}):_vm._e()],_vm._v(" "),(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(this.gamespageData.meta.play_with_live_dealer.banner),expression:"this.gamespageData.meta.play_with_live_dealer.banner"}],attrs:{"alt":_vm.getAltText(
                    this.gamespageData.meta.play_with_live_dealer.title,
                    this.gamespageData.meta.play_with_live_dealer.banner
                  )}}):_c('img',{attrs:{"src":this.gamespageData.meta.play_with_live_dealer.banner,"alt":_vm.getAltText(
                    this.gamespageData.meta.play_with_live_dealer.title,
                    this.gamespageData.meta.play_with_live_dealer.banner
                  )}}),_vm._v(" "),_c('div',{staticClass:"live-dealer-content"},[_c('div',{staticClass:"top-cont"},[_c('span',{staticClass:"span-h2 custom-font-1"},[_vm._v(_vm._s(this.gamespageData.meta.play_with_live_dealer.title))]),_vm._v(" "),_c('div',{staticClass:"rating-wrapper-large"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          this.gamespageData.meta.play_with_live_dealer.rating
                        ),"no-text":""}})],1),_vm._v(" "),_c('div',{staticClass:"rating-wrapper"},[_c('div',{staticClass:"radio-stars radio-stars-mob"},[_vm._l((_vm.getRoundedRating(
                          parseFloat(
                            this.gamespageData.meta.play_with_live_dealer
                              .rating
                          )
                        )),function(index){return _c('img',{key:index,attrs:{"src":_vm.$root.site_url +
                          _vm.$root.asset_path +
                          '/svg-icons/star-mob.svg',"alt":"Star Mobile"}})}),_vm._v(" "),_vm._l((5 -
                        _vm.getRoundedRating(
                          parseFloat(
                            this.gamespageData.meta.play_with_live_dealer
                              .rating
                          )
                        )),function(index){return _c('img',{key:index + 10,attrs:{"src":_vm.$root.site_url +
                          _vm.$root.asset_path +
                          '/svg-icons/star-mob-clr.svg',"alt":"Star Mobile Clear"}})})],2)])]),_vm._v(" "),(_vm.hideToplistLabelGB)?void 0:[(
                      this.gamespageData.meta.geo_provider_partners_data &&
                      this.gamespageData.meta.geo_provider_partners_data
                        .current
                    )?_c('a',{class:{
                      'cta cta-primary cta-yellow cta-yellow__lg z-index-2 custom-btn hover-btn cas-link': true,
                      'font-dark': _vm.getContrastYIQ(
                        _vm.$root.color_schema.primary_btn
                      ),
                      'font-light': !_vm.getContrastYIQ(
                        _vm.$root.color_schema.primary_btn
                      ),
                    },style:({
                      '--primary-btn': _vm.$root.color_schema.primary_btn,
                      '--primary-btn-hover': _vm.pSBC(
                        -0.2,
                        _vm.$root.color_schema.primary_btn
                      ),
                    }),attrs:{"title":this.gamespageData.meta.geo_provider_partners_data
                        .current.product_name,"href":_vm.getGoLink(
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.go_link,
                        this.gamespageData.meta.geo_provider_partners_data
                          .current.slug
                      ),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                        ? 'nofollow sponsored'
                        : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[_vm._v(_vm._s(this.gamespageData.meta.play_with_live_dealer
                        .button_label))]),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gambsdpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2):_vm._e()]],2)],2):_vm._e(),_vm._v(" "),(
                this.gamespageData.meta &&
                this.gamespageData.meta.our_expert_review &&
                Object.keys(this.gamespageData.meta.our_expert_review)
                  .length > 0 &&
                this.gamespageData.meta.our_expert_review.reviewer_image
              )?_c('div',{staticClass:"expert-review",style:({
                backgroundColor: _vm.pSBC(0.1, _vm.$root.color_schema.footer_bg),
              })},[_c('div',{staticClass:"expert-review-inner"},[_c('span',{staticClass:"span-h2 custom-font-1"},[_vm._v(_vm._s(this.gamespageData.meta.our_expert_review.title))]),_vm._v(" "),_c('div',{staticClass:"expert-info"},[_c('div',{staticClass:"expert-info-pic"},[(_vm.$root.enable_lazyload)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                        this.gamespageData.meta.our_expert_review
                          .reviewer_image
                      ),expression:"\n                        this.gamespageData.meta.our_expert_review\n                          .reviewer_image\n                      "}],attrs:{"alt":_vm.getAltText(
                          this.gamespageData.meta.our_expert_review.title,
                          this.gamespageData.meta.our_expert_review
                            .reviewer_image
                        )}}):_c('img',{attrs:{"src":this.gamespageData.meta.our_expert_review
                          .reviewer_image,"alt":_vm.getAltText(
                          this.gamespageData.meta.our_expert_review.title,
                          this.gamespageData.meta.our_expert_review
                            .reviewer_image
                        )}})]),_vm._v(" "),_c('div',{staticClass:"expert-info-right"},[_c('StarRating',{attrs:{"rating":parseFloat(
                          this.gamespageData.meta.our_expert_review
                            .review_rating
                        ),"no-text":""}}),_vm._v(" "),_c('span',{staticClass:"span-h6 custom-font-1"},[_vm._v(_vm._s(this.gamespageData.meta.our_expert_review.reviewer_name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$root.i18n.reviewed_on)+"\n                      "+_vm._s(this.gamespageData.meta.our_expert_review.review_date))])],1)]),_vm._v(" "),_c('div',{staticClass:"expert-review-bottom"},[_c('span',[_c('img',{attrs:{"src":_vm.$root.site_url +
                        _vm.$root.asset_path +
                        '/svg-icons/expert-icon.svg',"alt":"Expert Icon"}})]),_vm._v(" "),_c('p',{staticClass:"custom-font-2"},[_vm._v("\n                    "+_vm._s(this.gamespageData.meta.our_expert_review.review_content)+"\n                  ")])])])]):_vm._e()]],2)]):_vm._e()]),_vm._v(" "),(
        this.gamespageData.meta &&
        this.gamespageData.meta.geo_provider_partners_data &&
        this.gamespageData.meta.geo_provider_partners_data.current &&
        !this.gameTemplate
      )?_c('div',{staticClass:"play-casino-section"},[_c('div',{staticClass:"container mobile-scroll-container"},[(_vm.hideToplistLabelGB)?[_c('div',{staticClass:"text-center pt-10 font-light"},[_vm._v("\n            "+_vm._s(_vm.$root.i18n.no_toplist_available_intime)+"\n          ")])]:[(_vm.gamesTop3.length > 0)?_vm._l((_vm.gamesTop3),function(val,index){return _c('div',{key:index},[(val && val.length > 0)?_c('TagBlock',{attrs:{"attrs":{},"title":_vm.gamesTop3Title[index],"block":'gamepageBanner',"usTag":_vm.gamesTop3Attrs &&
                  _vm.gamesTop3Attrs.hasOwnProperty('title_tag') &&
                  _vm.gamesTop3Attrs.title_tag != ''
                    ? _vm.gamesTop3Attrs.title_tag
                    : 'span'}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile-scroller"},[_c('div',{staticClass:"row wd-auto"},_vm._l((val),function(data,index){return _c('div',{key:index,staticClass:"col-md-4 col-sm-4 mw-300"},[_c('div',{class:{
                        'play-card': true,
                        'term-recas':
                          (data.bonus_tc && data.bonus_tc != '') ||
                          (data.terms && data.terms != ''),
                        'top-choice': index === 0,
                        'rm-bottom-color':
                          index === 0 &&
                          ((data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != '')),
                      }},[_c('div',{staticClass:"play-card-top"},[_c('div',{staticClass:"play-card-top-img pos-relative"},[_c('a',{staticClass:"partner-logo cas-link",attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"rel":_vm.$root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow',"target":"_blank"}},[(
                                _vm.$root.enable_lazyload &&
                                _vm.assets_images &&
                                _vm.assets_images.pro_asset_sizes
                              )?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(
                                data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : ''
                              ),expression:"\n                                data.product_assets.filter(\n                                  (ele) =>\n                                    ele.asset_category_name ===\n                                    assets_images.pro_asset_sizes.medium\n                                ).length > 0\n                                  ? data.product_assets.filter(\n                                      (ele) =>\n                                        ele.asset_category_name ===\n                                        assets_images.pro_asset_sizes.medium\n                                    )[0].url\n                                  : ''\n                              "}],attrs:{"alt":_vm.getAltText(
                                  data.product_name,
                                  data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        function (ele) { return ele.asset_category_name ===
                                          _vm.assets_images.pro_asset_sizes.medium; }
                                      )[0].url
                                    : ''
                                )}}):(
                                _vm.assets_images && _vm.assets_images.pro_asset_sizes
                              )?_c('img',{attrs:{"src":data.product_assets.filter(
                                  function (ele) { return ele.asset_category_name ===
                                    _vm.assets_images.pro_asset_sizes.medium; }
                                ).length > 0
                                  ? data.product_assets.filter(
                                      function (ele) { return ele.asset_category_name ===
                                        _vm.assets_images.pro_asset_sizes.medium; }
                                    )[0].url
                                  : _vm.$root.site_url +
                                    _vm.$root.asset_path +
                                    '/failure.png',"alt":_vm.getAltText(
                                  data.product_name,
                                  data.product_assets.filter(
                                    function (ele) { return ele.asset_category_name ===
                                      _vm.assets_images.pro_asset_sizes.medium; }
                                  ).length > 0
                                    ? data.product_assets.filter(
                                        function (ele) { return ele.asset_category_name ===
                                          _vm.assets_images.pro_asset_sizes.medium; }
                                      )[0].url
                                    : _vm.$root.site_url +
                                        _vm.$root.asset_path +
                                        '/failure.png'
                                )}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"partner-hover wd-gam-cas"},[_c('div',{staticClass:"partner-hover-inner",style:({
                                  '--primary-btn':
                                    _vm.$root.color_schema.primary_btn,
                                  '--primary-btn-hover': _vm.pSBC(
                                    -0.2,
                                    _vm.$root.color_schema.primary_btn
                                  ),
                                })},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"}},[_c('path',{attrs:{"d":"M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z","fill":"white"}})])])]),_vm._v(" "),(Object.keys(_vm.hasTag(data.tags)).length > 0)?_c('div',{class:{
                                'stripe text-center': true,
                                'font-dark': _vm.getContrastYIQ(
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                    ? _vm.hasTag(data.tags).color
                                    : null
                                ),
                                'font-light': !_vm.getContrastYIQ(
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                    ? _vm.hasTag(data.tags).color
                                    : null
                                ),
                              },style:({
                                backgroundColor:
                                  Object.keys(_vm.hasTag(data.tags)).length > 0
                                    ? _vm.hasTag(data.tags).color
                                    : null,
                              })},[_c('img',{attrs:{"src":_vm.hasTag(data.tags).icon,"width":"18","height":"12","alt":"tag-icons"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"play-card-top-right gamefree-casino"},[_c('span',{staticClass:"span-h5 custom-font-1"},[(_vm.hideBonusLabelGB)?[_c('span',[_vm._v(_vm._s(_vm.$root.i18n.hidden_partner_bonus))])]:[_c('a',{staticClass:"bonus-link custom-font-1 cas-link",style:({
                                  '--color-hover':
                                    _vm.$root.color_schema.primary_btn,
                                }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'}},[(
                                    data.bonus_match &&
                                    data.exclusive_bonus_amount &&
                                    data.exclusive_bonus_match
                                  )?_c('span',[_vm._v(_vm._s(data.exclusive_bonus_match)+"%\n                                  "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                                  "+_vm._s(_vm._f("currency")(data.exclusive_bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(
                                    data.bonus_match &&
                                    !data.exclusive_bonus_amount &&
                                    data.bonus_amount
                                  )?_c('span',[_vm._v(_vm._s(data.bonus_match)+"%\n                                  "+_vm._s(_vm.$root.i18n.match_bonus_up_to)+"\n                                  "+_vm._s(_vm._f("currency")(data.bonus_amount,data.bonus_currency)))]):_vm._e(),_vm._v(" "),(data.freespin || data.freebie_name)?_c('span',[(
                                      (data.exclusive_bonus_amount ||
                                        data.bonus_amount) &&
                                      data.bonus_match
                                    )?[_vm._v("+")]:_vm._e(),_vm._v(" "),(data.freespin)?[(
                                        data.show_freebie_currency === '1'
                                      )?[_vm._v(_vm._s(_vm._f("currency")(data.freespin,data.bonus_currency)))]:[_vm._v(_vm._s(data.freespin))],_vm._v("\n                                    "+_vm._s(data.freebie_name)+"\n                                  ")]:[_vm._v(_vm._s(data.freebie_name))]],2):_vm._e()])]],2),_vm._v(" "),_c('div',{staticClass:"row mar-2"},[_c('StarRating',{attrs:{"rating":parseFloat((data.rating / 2).toFixed(1))}})],1)])]),_vm._v(" "),_c('a',{class:{
                          'cta cta-primary cta-promotion cta-block custom-btn hover-btn cas-link': true,
                          'text-white':
                            !_vm.$root.override_ctabtntxt_color &&
                            !_vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-gray':
                            !_vm.$root.override_ctabtntxt_color &&
                            _vm.getContrastYIQ(_vm.$root.color_schema.primary_btn),
                          'text-cta-override': _vm.$root.override_ctabtntxt_color,
                        },style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                          '--primary-btn-hover': _vm.pSBC(
                            -0.2,
                            _vm.$root.color_schema.primary_btn
                          ),
                        }),attrs:{"title":data.product_name,"href":_vm.getGoLink(data.go_link, data.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow'}},[_c('span',{staticClass:"cta-text"},[(index === 0)?_c('img',{attrs:{"src":_vm.crownIcon,"height":"16","width":"24","alt":"Crown"}}):_vm._e(),_vm._v("\n                          "+_vm._s(data.cta_button_text))]),_vm._v(" "),_vm._l((_vm.$root.i18n.go_to_casino),function(char,indexGo){return _c('span',{key:indexGo + "gamcpp",staticClass:"hover-text"},[_vm._v(_vm._s(char))])})],2),_vm._v(" "),(_vm.$root.enable_piwik_reload)?[(data.review_link)?_c('a',{staticClass:"read-review",attrs:{"title":data.product_name,"href":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                              _vm.$root.i18n.partner_name_review,
                              data.product_name
                            )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]:[(data.review_link)?_c('router-link',{staticClass:"read-review",attrs:{"title":data.product_name,"to":_vm.getRouteLink(data.review_link, 'review')}},[_vm._v(_vm._s(_vm.getPartnerGlobalString(
                              _vm.$root.i18n.partner_name_review,
                              data.product_name
                            )))]):_c('span',{staticClass:"emt-sp"},[_vm._v(" ")])]],2),_vm._v(" "),(
                        (data.bonus_tc && data.bonus_tc != '') ||
                        (data.terms && data.terms != '')
                      )?_c('div',{class:{
                        'cas-terms gam-term': true,
                        'terms-top-choice':
                          index === 0 &&
                          ((data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != '')),
                      }},[(data.bonus_tc && data.bonus_tc != '')?_c('span',{staticClass:"read-review cas-term",staticStyle:{"text-align":"center"},style:({
                          '--primary-btn': _vm.$root.color_schema.primary_btn,
                        }),domProps:{"innerHTML":_vm._s(data.bonus_tc.trim())}}):_vm._e(),_vm._v(" "),(
                          data.bonus_tc &&
                          data.terms &&
                          data.bonus_tc != '' &&
                          data.terms != ''
                        )?_c('span',{staticClass:"card-stroke"},[_vm._v("|")]):_vm._e(),_vm._v(" "),(data.terms && data.terms != '')?_c('a',{staticClass:"read-review cas-term",attrs:{"rel":_vm.$root.change_cta_to_sponsored
                            ? 'nofollow sponsored'
                            : 'nofollow',"title":data.product_name,"href":_vm.getGoLink(data.term_link, data.slug),"target":"_blank"}},[_vm._v(_vm._s(data.terms))]):_vm._e()]):_vm._e()])}),0)])],1)}):_vm._e()]],2)]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{class:{
      'block-wrapper': true,
      'custom-background-image': _vm.$root.color_schema.site_bg_img,
    },style:({
      '--bg-image': ("url(" + (_vm.$root.color_schema.site_bg_img) + ") repeat"),
      '--bg-color': _vm.$root.color_schema.site_bg_color,
    })},[(_vm.$root.color_schema.site_bg_img)?_c('a',{staticClass:"main-tag cas-link",attrs:{"href":_vm.getGoLink(_vm.$root.goto_link, _vm.$root.slug),"target":"_blank","rel":_vm.$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"observer",rawName:"v-observer:subtree",value:(_vm.mutationObserve),expression:"mutationObserve",arg:"subtree"}],class:{
        'custom-background-color': _vm.$root.color_schema.site_bg_img,
        'pb-25': true,
      }},[(
          !(this.gamespageData.meta && this.gamespageData.meta.banner_image)
        )?_c('section',{staticClass:"pt-26"},[_c('div',{staticClass:"container z-con overflow-auto"},[_c('div',{staticClass:"col-md-12"},[_c('Breadcrumb',{attrs:{"breadcrumbData":this.gamespageData.breadcrumb,"dark":true,"templateName":'',"gameBlockTitle":''}})],1)])]):_vm._e(),_vm._v(" "),_c('section',{class:{
          'ct-card-horizontal-game': true,
          'pt-20':
            this.gamespageData.meta && this.gamespageData.meta.banner_image,
        }},[(_vm.blockData)?[_vm._l((_vm.blockData),function(data,index){return [_c('CustomComponent',{key:((data.blockName) + "-" + index),attrs:{"blockData":data,"recommendSection":data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? _vm.recommend_section : {},"bluebar":data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? _vm.bluebar : {},"blockIndex":index}})]})]:_vm._e()],2),_vm._v(" "),(_vm.endOfblockData && _vm.morePaymentBottom)?[_c('RelatedLinks',{attrs:{"relatedLinkData":_vm.morePaymentBottom}})]:_vm._e(),_vm._v(" "),(_vm.auhtorBlockdata && _vm.endOfblockData)?void 0:_vm._e()],2)])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331378b8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/GameFree/GameFree.vue
// module id = 661
// module chunks = 1